import { useEffect, useState } from 'react';
import moment from 'moment';

const useCountdown = ({ deadlineTime = 0, format = 'HH:mm' }) => {
    const serverTime = moment().format('X');
    const [timeLeft, setTimeLeft] = useState(deadlineTime - serverTime);
    const [durationDays, setDurationDays] = useState('0');

    useEffect(
        () => {
            setTimeLeft(deadlineTime - serverTime);
        },
        [deadlineTime]
    );

    useEffect(
        () => {
            if (timeLeft <= 0) {
                setTimeLeft(0);
            }
            const interval = setInterval(() => {
                if (timeLeft > 0) {
                    setTimeLeft(timeLeft - 1);
                } else {
                    clearInterval(interval);
                }
            }, 1000);

            const duration = moment.duration(moment.utc(timeLeft * 1000));
            setDurationDays(duration.get('d')); // should be reworked

            return () => {
                clearInterval(interval);
            };
        },
        [timeLeft]
    );

    return {
        timeLeft:
            `${durationDays}:${moment.utc(timeLeft * 1000).format(format)}` ||
            0,
        isEnding: timeLeft <= 1800,
        timeIsOver: timeLeft <= 0,
    };
};

export default useCountdown;
